import { LeftArrow } from "@monsterindia/global-ui-components";
import { useRouter } from "next/navigation";
import React from "react";

type NavigationTopLabelProps = {
  isMobile: boolean;
  activeLabel: string;
  setActiveLabel: React.Dispatch<React.SetStateAction<string>>;
  currentQueryParams: URLSearchParams;
};

const NavigationTopLabel = ({
  isMobile,
  activeLabel,
  setActiveLabel,
}: NavigationTopLabelProps) => {
  const router = useRouter();

  const onBackclick = () => {
    router.back();
    setActiveLabel("");
  };

  return (
    <div
      className={`flex items-center border-b border-[#d2d1d6] p-3 font-semibold`}
    >
      {isMobile && (
        <div onClick={() => onBackclick()}>
          <LeftArrow className="text-black" width={24} height={24} />
        </div>
      )}

      <p className={`${isMobile ? "" : "text-xl font-bold"} `}>
        {activeLabel ? activeLabel : "Settings"}
      </p>
    </div>
  );
};

export default NavigationTopLabel;
